module.exports = __webpack_public_path__ + "static/media/login_background2.28c41b5f.jpg";